export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const DELETE_FLASH_MESSAGE = 'DELETE_FLASH_MESSAGE';
export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_PRINTSYSTEM_CONNECTED = 'SET_PRINTSYSTEM_CONNECTED';
export const SET_PRINTTERS = 'SET_PRINTTERS';